export const trimSpacesAndDashes = (str: string) => {
  // trim both spaces and dashes, leaving internal spaces and dashes
  const cleanedStr = str.replace(/^[ -]+|[ -]+$/g, '')
  return cleanedStr
}
